import {css} from "@emotion/react";

// Shared layout for dropdowns that split their menu into independently
// scrollable "Selected" and "Available" sections — the tag filters in
// data-config-toolbar.js and the client filter in infinite-list-select.js.
// Editing these affects all of those dropdowns.

// This menu is nested inside a plain wrapper that the slideDown animation
// (velocity) animates, so velocity's inline display/height never land on this
// element and plain "display: flex" is enough — no !important required.
export const dropdownContainerCss = css`
  display: flex;
  flex-direction: column;
  max-height: 60vh;
  overflow: hidden;
  margin-top: 0.5rem;
`;

export const dropdownHeadingCss = theme => css`
  flex: none;
  color: ${theme.palette.text.main};
  border-bottom: 1px solid ${theme.palette.background.paper};
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  padding: 0.5rem;
  margin-top: -7px;
  margin-bottom: 0.5rem;
`;

// Selected items size to their content and grow as items are added, up to half
// the dropdown height, then scroll on their own so they never leave the view.
export const selectedSectionCss = css`
  flex: 0 0 auto;
  max-height: 20vh;
  min-height: 0;
  overflow-y: auto;
`;

// The available list fills the space remaining below the selected section and
// shrinks as that section grows. Its overflow rule differs per dropdown, so
// compose it with one of the variants below:
//   - plain (non-virtualized) lists scroll themselves -> availableSectionScrollCss
//   - a virtualized react-window list manages its own scroll -> availableSectionVirtualizedCss
export const availableSectionCss = css`
  flex: 1 1 auto;
  min-height: 0;
`;

export const availableSectionScrollCss = css`
  overflow-y: auto;
`;

export const availableSectionVirtualizedCss = css`
  overflow: hidden;
`;

export const menuFooterCss = css`
  flex: none;
`;
